import { Component, Element, h, Host, Prop, State, Watch } from '@stencil/core';
import * as marked from 'marked';
export class MarkdownRenderer {
  constructor() {
    this.version = '1.1.0';
    this.updateCounter = 0; // force rerender when change
  }
  componentWillLoad() {
    if (!window.marked) {
      window.marked = this.initMarkedParser();
    }
  }
  componentWillRender() {
    this.setOutput();
  }
  handleSetOutput() {
    this.setOutput();
  }
  setOutput() {
    const textInput = this.getTextInput();
    this.output = window.marked.parse(textInput);
  }
  getTextInput() {
    const slot = this.getSlot();
    if (slot) {
      return slot.innerText;
    }
    console.error('No slot set for markdown renderer. No input available.');
    return '';
  }
  getSlot() {
    return this.el.querySelector('[slot="source"]');
  }
  initMarkedParser() {
    const underLineExtension = {
      name: 'underline',
      level: 'inline',
      start: (src) => { var _a; return (_a = src.match(/\+\+[^\+\+]*\+\+/)) === null || _a === void 0 ? void 0 : _a.index; },
      tokenizer(src) {
        const rule = /\+\+[^\+\+]*\+\+/gm;
        const match = rule.exec(src);
        if (match) {
          let text = match[0].replace(/^\+\+/, '')
            .replace(/\+\+$/, '')
            .trim();
          let subtext = src.substring(0, match.index + match[0].length);
          return {
            type: 'underline',
            raw: subtext,
            text: subtext,
            replaceFrom: match[0],
            replaceTo: text
          };
        }
      },
      renderer(token) {
        let out = token.replaceTo;
        const matches = out.match(/\*\*[^\*\*]*\*\*/g);
        if (matches) {
          matches.forEach(found => {
            let trimmed = found.replace(/^\*\*/, '')
              .replace(/\*\*$/, '')
              .trim();
            out = out.replace(found, '<strong>' + trimmed + '</strong>');
          });
        }
        return token.text.replace(token.replaceFrom, '<u>' + out + '</u>');
      }
    };
    marked.use({
      extensions: [underLineExtension]
    });
    /*
    const renderer = new (window as any).marked.Renderer();
    marked.setOptions({
      renderer: renderer
    });
    */
    return marked;
  }
  render() {
    return (h(Host, null,
      h("div", { class: "wrapper" },
        h("div", { class: "rendered-markdown", innerHTML: this.output }),
        h("div", { class: "source" },
          h("slot", { name: "source" })))));
  }
  static get is() { return "c-markdown-renderer"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["c-markdown-renderer.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["c-markdown-renderer.css"]
  }; }
  static get properties() { return {
    "version": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "'1.1.0'"
    },
    "updateCounter": {
      "type": "number",
      "mutable": true,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "update-counter",
      "reflect": true,
      "defaultValue": "0"
    }
  }; }
  static get states() { return {
    "output": {}
  }; }
  static get elementRef() { return "el"; }
  static get watchers() { return [{
      "propName": "updateCounter",
      "methodName": "handleSetOutput"
    }]; }
}
